import { List, Avatar } from 'antd';
import React, {useContext} from 'react';
import "./leftSection.scss";
import {SocketContext} from "../../../SocketContext";

const LeftSection = ({openDrawer, converstaions, selectedConversationId, selectedCnv}) => {

  const socket = useContext(SocketContext);

  return <div>
    <h4>All Conversations</h4>

    <h5 style={ {
      marginTop: 20
    } }>Recent Chats</h5>
    <List
      style={{
        width:300
      }}
      itemLayout="horizontal"
      dataSource={ converstaions }
      renderItem={ (item, index) => (

        <List.Item className={"conversationContent"} onClick={async ()=> {
          if(selectedConversationId !== item?.id || selectedConversationId === null){
            socket && socket.emit('join', item?.id)
            socket && socket.emit('leave', selectedConversationId)
            selectedCnv(item?.id)
          }
          window.innerWidth < 800 && openDrawer()
        } }
        style={{
          background: selectedConversationId === item?.id && "lightblue",
          borderRadius:10,
          cursor:"pointer"
        }}
        >
          <List.Item.Meta
            avatar={ <Avatar src={ !!item?.participants[0]?.user?.photo ? item?.participants[0]?.user?.photo : `https://api.dicebear.com/7.x/miniavs/svg?seed=${ index }` }/> }
            title={ item?.participants[0]?.user?.name || item?.participants[0]?.user?.email  }
            description={ item?.lastMessage?.message || ''}
          />
        </List.Item>
      ) }
    />
  </div>
}

export default LeftSection